import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from '../pages/login/LoginPage';
import MainPage from '../pages/main/main';
import AnimalMainPage from '../pages/animal/main';
import AnimalManagePage from '../pages/animal/manage';
import FinancePage from '../pages/finance/index';

// ProtectedRoute component
function ProtectedRoute({ children }) {
  const authToken = localStorage.getItem('authToken');
  return authToken ? children : <Navigate to="/" replace />;
}

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage/>} />
        <Route path="/home" element={<ProtectedRoute><MainPage/></ProtectedRoute>} />
        <Route path="/animal" element={<ProtectedRoute><AnimalMainPage/></ProtectedRoute>} />
        <Route path="/finance" element={<ProtectedRoute><FinancePage/></ProtectedRoute>} />
        <Route path="/animal/manage" element={<ProtectedRoute><AnimalManagePage/></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default AppRouter;